export const ORG_ID = 'ZD1RP';
export const DEFAULT_SAMPLE_RATE = 0.0125;
export const UB_ADMIN_SAMPLE_RATE = 0.1;
export const UB_LEARNER_SAMPLE_RATE = 0.05;
export const CONSUMER_SUBS_SAMPLE_RATE = 0.05;

// We have to use a disallow list to prevent being rate limited in the FS event API
export const DISALLOWED_EVENTS = ['DiscoveryItemImpressionEvent', 'PriceImpressionEvent', 'QuickViewBoxOpenEvent'];
//# sourceMappingURL=constants.js.map